// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./shared/font/gteestiprodisplay_regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./shared/font/gteestiprodisplay_light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayExtra";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayLight";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: normal;
}
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

.video-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-wrapper video {
  width: 400px;
  height: 700px;
}
@media (max-width: 430px) {
  .video-wrapper video {
    width: 90%;
    height: auto;
  }
}

p {
  margin: 0;
  padding: 0;
}

img {
  margin: 0;
  padding: 0;
  font-size: 0;
}

.mobile-container {
  max-width: 350px;
  width: 100%;
  margin: 0 auto;
}

button {
  padding: 0;
  border: none;
  font: inherit;
  color: inherit;
  background-color: transparent;
  cursor: pointer;
}

.container {
  max-width: 1216px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}

.mobile-header {
  position: relative;
  margin: 50px 0;
}
.mobile-header h4 {
  font-size: 28px;
  color: #000;
  font-family: GteDisplayExtra;
  text-align: center;
}
.mobile-header a {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
}

.main-input {
  width: 100%;
  position: relative;
}
.main-input.password button {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 25px;
  font-size: 0;
  margin: 0;
  padding: 0;
}
.main-input label {
  position: absolute;
  top: 12px;
  left: 20px;
  font-family: GteDisplayLight;
  font-size: 12px;
  color: #C2C2C2;
}
.main-input input {
  display: block;
  font-family: GteDisplayBold;
  padding: 27px 20px 13px 20px;
  background: #FAFAFA;
  border-radius: 30px;
  border: none;
  outline: none;
  font-size: 16px;
  color: #000;
}
.main-input input::placeholder {
  color: #C2C2C2;
}

.password-input {
  position: relative;
}

.green-button {
  width: 100%;
  padding: 14px 0;
  text-align: center;
  color: #000;
  background: #C7FF24;
  font-size: 16px;
  line-height: 16px;
  font-family: GteDisplayBold;
  border-radius: 30px;
  text-decoration: none;
}

@media (max-width: 430px) {
  body {
    overflow-x: hidden;
  }
  .container {
    padding: 0 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAEA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAEA;EACE,8BAAA;EACA,kBAAA;EACA,+DAAA;EACA,mBAAA;AAAF;AAGA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AADF;;AAIA;EACE,SAAA;EACA,UAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE;IACE,UAAA;IACA,YAAA;EAAJ;AACF;;AAIA;EACE,SAAA;EACA,UAAA;AADF;;AAIA;EACE,SAAA;EACA,UAAA;EACA,YAAA;AADF;;AAIA;EACE,gBAAA;EACA,WAAA;EACA,cAAA;AADF;;AAIA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;AADF;;AAIA;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,cAAA;AADF;AAEE;EACE,eAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,6BAAA;AAAJ;;AAIA;EACE,WAAA;EACA,kBAAA;AADF;AAII;EACE,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAFN;AAME;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;AAJJ;AAOE;EACE,cAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AALJ;AAOI;EACE,cAAA;AALN;;AAUA;EACE,kBAAA;AAPF;;AAYA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,qBAAA;AATF;;AAYA;EACE;IACE,kBAAA;EATF;EAWA;IACE,eAAA;EATF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap');\r\n\r\n@font-face {\r\n  font-family: \"GteDisplayBold\";\r\n  src: url('./shared/font/gteestiprodisplay_regular.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayExtra\";\r\n  src: url('./shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayLight\";\r\n  font-style: normal;\r\n  src: url('./shared/font/gteestiprodisplay_light.otf') format(\"truetype\");\r\n  font-weight: normal;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6 {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.video-wrapper {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.750);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  video {\r\n    width: 400px;\r\n    height: 700px;\r\n  }\r\n  @media (max-width: 430px) {\r\n    video {\r\n      width: 90%;\r\n      height: auto;\r\n    }\r\n  }\r\n}\r\n\r\np {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nimg {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 0;\r\n}\r\n\r\n.mobile-container {\r\n  max-width: 350px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\nbutton {\r\n  padding: 0;\r\n  border: none;\r\n  font: inherit;\r\n  color: inherit;\r\n  background-color: transparent;\r\n  cursor: pointer;\r\n}\r\n\r\n.container {\r\n  max-width: 1216px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  padding: 0 20px;\r\n}\r\n\r\n.mobile-header {\r\n  position: relative;\r\n  margin: 50px 0;\r\n  h4 {\r\n    font-size: 28px;\r\n    color: #000;\r\n    font-family: GteDisplayExtra;\r\n    text-align: center;\r\n  }\r\n  a {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 0;\r\n    transform: translate(0, -50%);\r\n  }\r\n}\r\n\r\n.main-input {\r\n  width: 100%;\r\n  position: relative;\r\n\r\n  &.password {\r\n    button {\r\n      position: absolute;\r\n      top: 50%;\r\n      transform: translate(0, -50%);\r\n      right: 25px;\r\n      font-size: 0;\r\n      margin: 0;\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  label {\r\n    position: absolute;\r\n    top: 12px;\r\n    left: 20px;\r\n    font-family: GteDisplayLight;\r\n    font-size: 12px;\r\n    color: #C2C2C2;\r\n  }\r\n\r\n  input {\r\n    display: block;\r\n    font-family: GteDisplayBold;\r\n    padding: 27px 20px 13px 20px;\r\n    background: #FAFAFA;\r\n    border-radius: 30px;\r\n    border: none;\r\n    outline: none;\r\n    font-size: 16px;\r\n    color: #000;\r\n    \r\n    &::placeholder {\r\n      color: #C2C2C2;\r\n    }\r\n  }\r\n}\r\n\r\n.password-input {\r\n  position: relative;\r\n\r\n\r\n}\r\n\r\n.green-button {\r\n  width: 100%;\r\n  padding: 14px 0;\r\n  text-align: center;\r\n  color: #000;\r\n  background: #C7FF24;\r\n  font-size: 16px;\r\n  line-height: 16px;\r\n  font-family: GteDisplayBold;\r\n  border-radius: 30px;\r\n  text-decoration: none;\r\n}\r\n\r\n@media (max-width: 430px) {\r\n  body {\r\n    overflow-x: hidden;\r\n  }\r\n  .container {\r\n    padding: 0 10px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
